/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Lush_Hare_ReadInputs */

const en_thin_lush_hare_read = /** @type {(inputs: Thin_Lush_Hare_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey Participation`)
};

const de_thin_lush_hare_read = /** @type {(inputs: Thin_Lush_Hare_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungsteilnahme`)
};

/**
* | output |
* | --- |
* | "Survey Participation" |
*
* @param {Thin_Lush_Hare_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_lush_hare_read = /** @type {((inputs?: Thin_Lush_Hare_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Lush_Hare_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_lush_hare_read(inputs)
	return de_thin_lush_hare_read(inputs)
});